export default {"src":"/_next/static/media/AccessFooter.e96ddad6.svg","height":280,"width":2055};